"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropertiesSelector = void 0;
var react_1 = require("react");
var uom_1 = require("uom");
var property_1 = require("@promaster-sdk/property");
var PropertyFiltering = __importStar(require("@promaster-sdk/property-filter-pretty"));
var exhaustive_check_1 = require("@promaster-sdk/property/lib/utils/exhaustive-check");
function usePropertiesSelector(options) {
    var requiredOptions = optionsWithDefaults(options);
    var propertiesUnsorted = requiredOptions.properties, selectedProperties = requiredOptions.selectedProperties, includeHiddenProperties = requiredOptions.includeHiddenProperties, valueComparer = requiredOptions.valueComparer, propertyComparer = requiredOptions.propertyComparer, getPropertyInfo = requiredOptions.getPropertyInfo, showCodes = requiredOptions.showCodes, getItemFilter = requiredOptions.getItemFilter, getItemValue = requiredOptions.getItemValue, getPropertyItems = requiredOptions.getPropertyItems;
    // Get sorted properties and only include the ones that should be visible
    var properties = propertiesUnsorted
        .slice()
        .sort(propertyComparer)
        .filter(function (property) {
        var pi = getPropertyInfo(property);
        return includeHiddenProperties || property_1.PropertyFilter.isValid(selectedProperties, pi.visibilityFilter, valueComparer);
    });
    var selectorHookMap = new Map(properties.map(function (p) { return [p, createSelectorHookInfo(p, requiredOptions)]; }));
    var _d = react_1.useState(requiredOptions.initiallyClosedGroups), closedGroups = _d[0], setClosedGroups = _d[1];
    return {
        getPropertySelectorHook: function (property) { return selectorHookMap.get(property); },
        getGroupToggleButtonProps: function (group) { return ({
            onClick: function () {
                return setClosedGroups(closedGroups.indexOf(group) >= 0 ? closedGroups.filter(function (g) { return g !== group; }) : __spreadArray(__spreadArray([], closedGroups), [group]));
            },
        }); },
        getPropertyLabel: function (property, propertyText) {
            return propertyText + (showCodes ? " (" + getPropertyInfo(property).name + ")" : "");
        },
        isPropertyHidden: function (property) {
            var isHidden = !property_1.PropertyFilter.isValid(selectedProperties, getPropertyInfo(property).visibilityFilter, valueComparer);
            return isHidden;
        },
        isPropertyValid: function (property) {
            var pi = getPropertyInfo(property);
            var selectedItemValue = property_1.PropertyValueSet.getValue(pi.name, selectedProperties);
            var selectedItem = getSelectedItem(selectedItemValue, property, getItemValue, getPropertyItems, valueComparer);
            return getIsValid(pi, selectedItem, selectedProperties, valueComparer, getItemFilter);
        },
        isGroupClosed: function (group) { return closedGroups.indexOf(group) !== -1; },
        getGroupProperties: function (group) {
            return properties.filter(function (property) { return getPropertyInfo(property).group === (group || ""); });
        },
        groups: getDistinctGroupNames(properties.map(getPropertyInfo)),
    };
}
exports.usePropertiesSelector = usePropertiesSelector;
function createSelectorHookInfo(property, options) {
    var selectedProperties = options.selectedProperties, propertyFormats = options.propertyFormats, valueComparer = options.valueComparer, properties = options.properties, autoSelectSingleValidValue = options.autoSelectSingleValidValue, showCodes = options.showCodes, inputDebounceTime = options.inputDebounceTime, valueMustBeNumericMessage = options.valueMustBeNumericMessage, valueIsRequiredMessage = options.valueIsRequiredMessage, onChange = options.onChange, optionalProperties = options.optionalProperties, filterPrettyPrint = options.filterPrettyPrint, units = options.units, unitsFormat = options.unitsFormat, onPropertyFormatChanged = options.onPropertyFormatChanged, onPropertyFormatCleared = options.onPropertyFormatCleared, lockSingleValidValue = options.lockSingleValidValue, readOnlyProperties = options.readOnlyProperties, sortValidFirst = options.sortValidFirst, getUndefinedValueItem = options.getUndefinedValueItem, getItemValue = options.getItemValue, getItemFilter = options.getItemFilter, itemComparer = options.itemComparer, getPropertyInfo = options.getPropertyInfo, getPropertyItems = options.getPropertyItems;
    var propertyInfo = getPropertyInfo(property);
    var selectedItemValue = property_1.PropertyValueSet.getValue(propertyInfo.name, selectedProperties);
    var selectedItem = getSelectedItem(selectedItemValue, property, getItemValue, getPropertyItems, valueComparer);
    // TODO: Better handling of format to use when the format is missing in the map
    var defaultFormat = getDefaultFormat(propertyInfo, selectedItemValue);
    var propertyFormat = propertyFormats[propertyInfo.name] || defaultFormat;
    var readOnly = readOnlyProperties.indexOf(propertyInfo.name) !== -1;
    var propertyOnChange = handleChange(onChange, properties, autoSelectSingleValidValue, valueComparer, getItemValue, getItemFilter, getPropertyInfo, getPropertyItems);
    var propertyName = propertyInfo.name;
    // const valueItems = propertyInfo.items;
    var locked = autoSelectSingleValidValue || lockSingleValidValue
        ? shouldBeLocked(selectedItem, getPropertyItems(property), propertyInfo, selectedProperties, valueComparer, getItemFilter)
        : false;
    function onValueChange(newValue) {
        propertyOnChange(newValue
            ? property_1.PropertyValueSet.set(propertyName, newValue, selectedProperties)
            : property_1.PropertyValueSet.removeProperty(propertyName, selectedProperties), propertyName);
    }
    var selectorType = getSelectorType(propertyInfo);
    switch (selectorType) {
        case "TextBox": {
            return {
                type: "TextBox",
                getUseTextboxOptions: function () { return ({
                    propertyName: propertyName,
                    propertyValueSet: selectedProperties,
                    readOnly: readOnly,
                    onValueChange: onValueChange,
                    debounceTime: inputDebounceTime,
                }); },
            };
        }
        case "AmountField": {
            return {
                type: "AmountField",
                getUseAmountOptions: function () { return ({
                    propertyName: propertyName,
                    propertyValueSet: selectedProperties,
                    inputUnit: propertyFormat.unit,
                    inputDecimalCount: propertyFormat.decimalCount,
                    onFormatChanged: function (unit, decimalCount) {
                        return onPropertyFormatChanged(propertyName, unit, decimalCount);
                    },
                    onFormatCleared: function () { return onPropertyFormatCleared(propertyName); },
                    onValueChange: onValueChange,
                    notNumericMessage: valueMustBeNumericMessage,
                    fieldName: propertyInfo.fieldName || propertyInfo.name,
                    // If it is optional then use blank required message
                    isRequiredMessage: optionalProperties && optionalProperties.indexOf(propertyName) !== -1 ? "" : valueIsRequiredMessage,
                    validationFilter: propertyInfo.validationFilter,
                    filterPrettyPrint: filterPrettyPrint,
                    readOnly: readOnly,
                    debounceTime: inputDebounceTime,
                    unitsFormat: unitsFormat,
                    units: units,
                }); },
            };
        }
        case "Discrete":
            return {
                type: "Discrete",
                getUseDiscreteOptions: function () { return ({
                    getUndefinedValueItem: getUndefinedValueItem,
                    getItemValue: getItemValue,
                    getItemFilter: getItemFilter,
                    sortValidFirst: sortValidFirst,
                    propertyName: propertyName,
                    propertyValueSet: selectedProperties,
                    items: getPropertyItems(property),
                    showCodes: showCodes,
                    filterPrettyPrint: filterPrettyPrint,
                    onValueChange: onValueChange,
                    disabled: readOnly || locked,
                    itemComparer: itemComparer,
                }); },
            };
        default:
            return exhaustive_check_1.exhaustiveCheck(selectorType, true);
    }
}
function getSelectedItem(selectedItemValue, property, getItemValue, getPropertyItems, valueComparer) {
    var items = getPropertyItems(property);
    var selectedItem = items &&
        items.find(function (item) {
            var itemValue = getItemValue(item);
            return ((itemValue === undefined && selectedItemValue === undefined) ||
                (itemValue && property_1.PropertyValue.equals(selectedItemValue, itemValue, valueComparer)));
        });
    return selectedItem;
}
function getDefaultFormat(property, selectedValue) {
    var defaultFormat = { unit: uom_1.Unit.One, decimalCount: 2 };
    var propertyType = getPropertyType(property.quantity);
    switch (propertyType) {
        case "text":
        case "integer":
            return defaultFormat;
        case "amount":
            return selectedValue && selectedValue.type === "amount"
                ? {
                    unit: selectedValue.value.unit,
                    decimalCount: selectedValue.value.decimalCount,
                }
                : defaultFormat;
        default:
            return exhaustive_check_1.exhaustiveCheck(propertyType, true);
    }
}
function getIsValid(property, selectedValueItem, selectedProperties, comparer, getItemFilter) {
    switch (getPropertyType(property.quantity)) {
        case "integer":
            return selectedValueItem
                ? property_1.PropertyFilter.isValid(selectedProperties, getItemFilter(selectedValueItem), comparer)
                : false;
        case "amount":
            return (property.validationFilter && property_1.PropertyFilter.isValid(selectedProperties, property.validationFilter, comparer));
        default:
            return true;
    }
}
function getSelectorType(propertyInfo) {
    if (propertyInfo.quantity === "Text") {
        return "TextBox";
    }
    else if (propertyInfo.quantity === "Discrete") {
        return "Discrete";
    }
    else {
        return "AmountField";
    }
}
function getPropertyType(quantity) {
    switch (quantity) {
        case "Text":
            return "text";
        case "Discrete":
            return "integer";
        default:
            return "amount";
    }
}
function shouldBeLocked(selectedValueItem, propertyItems, propertyInfo, properties, comparer, getItemFilter) {
    var singleValidValue = getSingleValidItemOrUndefined(propertyItems, propertyInfo, properties, comparer, getItemFilter);
    // getSingleValidValueOrUndefined only works on onChange.
    // Prevent locking when the sent in selectedValue isn't the singleValidValue
    if (singleValidValue && singleValidValue === selectedValueItem) {
        return true;
    }
    return false;
}
function handleChange(externalOnChange, productProperties, autoSelectSingleValidValue, comparer, getItemValue, getItemFilter, getPropertyInfo, getPropertyItems) {
    return function (properties, propertyName) {
        if (!autoSelectSingleValidValue) {
            externalOnChange(properties, [propertyName]);
            return;
        }
        var lastProperties = properties;
        var changedProps = new Set([propertyName]);
        for (var i = 0; i < 4; i++) {
            for (var _i = 0, productProperties_1 = productProperties; _i < productProperties_1.length; _i++) {
                var property = productProperties_1[_i];
                var propertyInfo = getPropertyInfo(property);
                if (propertyInfo.name === propertyName) {
                    continue;
                }
                var propertyItems = getPropertyItems(property);
                var singleItem = getSingleValidItemOrUndefined(propertyItems, propertyInfo, properties, comparer, getItemFilter);
                var singleItemValue = singleItem && getItemValue(singleItem);
                if (singleItem && singleItemValue) {
                    properties = property_1.PropertyValueSet.set(propertyInfo.name, singleItemValue, properties);
                    changedProps.add(propertyInfo.name);
                }
            }
            if (properties === lastProperties) {
                break;
            }
            lastProperties = properties;
        }
        externalOnChange(properties, Array.from(changedProps.keys()));
    };
}
function getSingleValidItemOrUndefined(propertyItems, propertyInfo, properties, comparer, getItemFilter) {
    if (propertyInfo.quantity === "Discrete") {
        var validPropertyValueItems = [];
        for (var _i = 0, propertyItems_1 = propertyItems; _i < propertyItems_1.length; _i++) {
            var productValueItem = propertyItems_1[_i];
            var isValid = property_1.PropertyFilter.isValid(properties, getItemFilter(productValueItem), comparer);
            if (isValid) {
                validPropertyValueItems.push(productValueItem);
            }
        }
        return validPropertyValueItems.length === 1 ? validPropertyValueItems[0] : undefined;
    }
    return undefined;
}
function getDistinctGroupNames(pis) {
    var groupNames = [];
    for (var _i = 0, pis_1 = pis; _i < pis_1.length; _i++) {
        var pi = pis_1[_i];
        // let groupName = property.groupName;
        if (isNullOrWhiteSpace(pi.group)) {
            // groupName = "";
        }
        if (groupNames.indexOf(pi.group) === -1) {
            groupNames.push(pi.group);
        }
    }
    return groupNames;
}
function isNullOrWhiteSpace(str) {
    return str === null || str === undefined || str.length < 1 || str.replace(/\s/g, "").length < 1;
}
function optionsWithDefaults(options) {
    return __assign(__assign({}, options), { filterPrettyPrint: options.filterPrettyPrint ||
            (function (propertyFilter) {
                return PropertyFiltering.filterPrettyPrintIndented(PropertyFiltering.buildEnglishMessages(options.unitsFormat), 2, " ", propertyFilter, options.unitsFormat, options.unitLookup);
            }), showCodes: options.showCodes || false, includeHiddenProperties: options.includeHiddenProperties || false, autoSelectSingleValidValue: options.autoSelectSingleValidValue || true, lockSingleValidValue: options.lockSingleValidValue || false, onChange: options.onChange || (function (_a, _propertyName) { return ({}); }), onPropertyFormatChanged: options.onPropertyFormatChanged || (function (_a, _b, _c) { return ({}); }), onPropertyFormatCleared: options.onPropertyFormatCleared || (function (_a) { return ({}); }), valueMustBeNumericMessage: options.valueMustBeNumericMessage || "value_must_be_numeric", valueIsRequiredMessage: options.valueIsRequiredMessage || "value_is_required", readOnlyProperties: options.readOnlyProperties || [], optionalProperties: options.optionalProperties || [], propertyFormats: options.propertyFormats || {}, inputDebounceTime: options.inputDebounceTime || 350, initiallyClosedGroups: options.initiallyClosedGroups || [], valueComparer: options.valueComparer || property_1.PropertyValue.defaultComparer, sortValidFirst: options.sortValidFirst || false, itemComparer: options.itemComparer || (function () { return 0; }), propertyComparer: options.propertyComparer || (function () { return 0; }) });
}
//# sourceMappingURL=use-properties-selector.js.map